<template>
  <div id="app" v-title data-title="缙云县先锋工具">
    <router-view />
  </div>
</template>

<style>
a {
  text-decoration: none;
}

html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
  font-size: 14px !important;
}
</style>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>
